import Vue from 'vue';
import Component from 'vue-class-component';
import ValidationTexts from '@/validations';

/**
 * Mixin handling everything related to validations
 */
@Component
export default class ValidationMixin extends Vue {
    /**
     * Check if a field needs validation
     * @param errors The errors for the field
     * @return True if the field needs validation
     */
    get unvalidated(): CallableFunction {
        return (errors: any[]): boolean => {
            if (errors && errors.length > 0) {
                return true;
            }
            return false;
        };
    }

    /**
     * Get the validation text
     * @param code The error name
     * @param ns The namespace
     * @return The validation text (to be translated later)
     */
    get validationText(): CallableFunction {
        return (code: string, ns: string): string => {
            const texts = this.validationTexts[ns] || {};
            return texts[code] || code;
        };
    }

    /**
     * Get the validation texts for the whole program
     */
    get validationTexts(): {[key: string]: any} {
        return ValidationTexts;
    }
}
